import { useCallback, useEffect, useState } from 'react';
import { api, type Me, type SiteSiparisOzetiVerisi, type SiteSiparisSatiri } from './api';
import { ORTAK } from './metin/ortak';
import { tarihSaatBae, tutarMetni } from './web-sitesi-bicim';
import { SITE_SIPARIS_OZETI as M } from './metin/site-siparis-ozeti';
import './site-siparis-ozeti.css';

function Siparis({ row, paid }: { row: SiteSiparisSatiri; paid: boolean }) {
  const stamp = paid ? row.paidAt : row.placedAt;
  const query = new URLSearchParams({ sekme: 'siparisler', q: row.reference, siparis: row.reference });
  return <li className="site-siparis-satiri">
    <div><a href={`/web-sitesi?${query}`}>{row.reference}</a><span className={`site-siparis-durum${paid ? ' site-siparis-odendi' : ''}`}>{M.durum[row.state]}</span></div>
    {row.totalMinor !== null && row.currencyCode !== null ? <strong><span className="site-siparis-tutar-etiketi">{M.siparisTutari}: </span>{tutarMetni(row.totalMinor, row.currencyCode)}</strong> : null}
    <small>{paid ? M.tahsilatTarihi : M.siparisTarihi}: {stamp ? <time dateTime={stamp}>{tarihSaatBae(stamp)}</time> : M.bilinmiyor}</small>
  </li>;
}

function SiparisListeleri() {
  const [data, setData] = useState<SiteSiparisOzetiVerisi | null>(null);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(true);
  const load = useCallback(async () => {
    setLoading(true); setError(false);
    try { setData(await api.dashboardWebOrders()); }
    catch { setError(true); }
    finally { setLoading(false); }
  }, []);
  useEffect(() => { void load(); }, [load]);
  if (error) return <div role="alert">{M.hata} <button type="button" onClick={() => void load()}>{ORTAK.yeniden}</button></div>;
  if (loading || !data) return <p role="status">{M.yukleniyor}</p>;
  return <div className="site-siparis-listeler">
    <section aria-labelledby="site-tahsilatlar"><h3 id="site-tahsilatlar">{M.tahsilatlar}</h3>
      {data.paid.length ? <ul>{data.paid.map((row) => <Siparis key={row.reference} row={row} paid />)}</ul> : <p>{M.bosTahsilat}</p>}
    </section>
    <section aria-labelledby="site-diger"><h3 id="site-diger">{M.diger}</h3><p>{M.digerAciklama}</p>
      {data.other.length ? <ul>{data.other.map((row) => <Siparis key={row.reference} row={row} paid={false} />)}</ul> : <p>{M.bosDiger}</p>}
    </section>
  </div>;
}

/** General opening page, not a sales sub-tab. No request without the underlying read permission. */
export function SiteSiparisOzeti({ me }: { me: Me }) {
  if (!me.permissions.includes('web_intake:read')) return null;
  return <section className="content-section site-siparis-ozeti" aria-labelledby="site-siparis-baslik" data-testid="site-orders-overview">
    <div className="section-heading"><h2 id="site-siparis-baslik">{M.baslik}</h2><a href="/web-sitesi?sekme=siparisler">{M.tumu}</a></div>
    <p>{M.aciklama}</p>
    {me.permissions.includes('finance:read') && me.permissions.includes('commerce:finance_read') ? <p><a href="/web-sitesi?sekme=odemeler">{M.denemeler}</a></p> : null}
    <SiparisListeleri />
  </section>;
}
